import React from "react";
import Maincontent from "../../Components/Maincontent";
import "./style.css";
export default function Index() {
  return (
    <Maincontent />
  );
}


